// src/lib/seo.ts
//
// Small helper that builds a consistent Next.js Metadata object for public
// marketing pages: page title + description, a canonical URL, and matching
// OpenGraph + Twitter cards. The root layout (src/app/layout.tsx) sets
// metadataBase + sensible OG/Twitter defaults; this layers per-page overrides
// so each marketing page has its own share card and canonical instead of
// inheriting the homepage's. Audit finding: pages were missing canonical tags
// and shared the layout's generic OG card.

import type { Metadata } from 'next'

export const SITE_URL = 'https://unlimitedtests.com'

export function pageSeo({
  title,
  description,
  path,
}: {
  title: string
  description: string
  /** Absolute path starting with "/", e.g. "/pricing". "/" for the homepage. */
  path: string
}): Metadata {
  const url = path === '/' ? SITE_URL : `${SITE_URL}${path}`
  return {
    title,
    description,
    alternates: { canonical: path },
    openGraph: { type: 'website', url, title, description },
    twitter: { card: 'summary_large_image', title, description },
  }
}
